(function () {
    $(".js-tosrus-gallery-item").tosrus({
        caption: {
            add: true,
            attributes: ["title", "data-img-caption"]
        },
        effect: "fade",
        pagination: {
            add: true,
            type: "thumbnails"
        },

        keys: {
            next: 39,
            prev: 37,
            close: 27
        }
    });

})();
